<app-chat [chatType]="chatType.GENERIC"
          description="This chatbot is configured to answer your questions."
></app-chat>
